<template>
  <b-overlay :show="loading" opacity="0.5">
    <div>
      <b-modal
        id="import-file-modal"
        :visible="isImportFileActive"
        size="lg"
        centered
        hide-footer
        @hidden="resetForm"
        @hide="resetForm"
        @change="(val) => $emit('update:is-import-file-active', val)"
      >
        <template #modal-header>
          <div class="d-flex justify-content-end px-2 mt-2 w-100">
            <feather-icon
              class="ml-1 cursor-pointer"
              icon="XIcon"
              size="20"
              @click="() => $emit('update:is-import-file-active', false)"
            />
          </div>
        </template>

        <b-overlay :show="loading" opacity="0.5">
          <b-form-file
            v-show="false"
            ref="import_file"
            accept="audio/*"
            placeholder=""
            @input="onFileRenderer"
          ></b-form-file>

          <div
            class="text-center p-3 mx-2 mb-4"
            style="border-style: dashed; border-width: 2px;"
            @drop="onDrop($event)"
            @dragover.prevent
            @dragenter.prevent
          >
            <div v-if="!updatedFile">
              <feather-icon
                class="mb-1 cursor-pointer text-primary"
                icon="UploadCloudIcon"
                size="80"
              />
              <h1 class="text-dark">
                Drag and drop audio file here
              </h1>
              <h2 class="text-muted">
                or
              </h2>
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="mr-1"
                @click="onBrowseFiles"
              >
                <span class="align-middle">Browse Audio Files</span>
              </b-button>
            </div>
            <div v-else>
              <h4>File Selected:</h4>
              <div class="my-2">
                {{ updatedFile.name }}
              </div>

              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="mr-1"
                @click="resetForm"
              >
                <span class="align-middle">Change audio file</span>
              </b-button>
              <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="primary"
                class="mr-1"
                @click="onProceed"
              >
                <span class="align-middle">Proceed</span>
              </b-button>
            </div>
          </div>
        </b-overlay>
      </b-modal>
    </div>
  </b-overlay>
</template>

<script>
import {
  BOverlay,
  BButton,
  BModal,
  BFormFile,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";

import { get } from "lodash"
import { required } from "@validations";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'


export default {
  components: {
    BModal,
    BOverlay,
    BButton,
    BFormFile,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    isImportFileActive: {
      type: Boolean,
      required: false
    },
    consultationId: {
      type: [String, null],
      required: false,
      default: () => null
    },
  },
  data() {
    return {
      loading: false,
      errorMessage: "",
      required,
      attachmentPath: '',
      updatedFile: null,
    };
  },
  methods: {
    async onProceed() {
      try {
        this.loading = true;

        const formData = new FormData();

        if (this.updatedFile) {
          formData.append("auscultation", this.updatedFile);
          formData.append("consultation_id", this.consultationId)
        }

        await this.useJwt().mainService.auscultations.upload(formData);
        if (this.updatedFile) {
          this.updatedFile = null;
        }

        this.$emit('refetchData')
        this.$emit('update:is-import-file-active', false)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            variant: 'success',
            icon: 'CheckCircleIcon',
            text: `Auscultation uploaded successfully.`
          },
        });
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
    onBrowseFiles() {
      const import_file_ref = this.$refs.import_file
      import_file_ref.$el.childNodes[0].click();
    },
    onDrop(e) {
      e.preventDefault()
      const files = e.dataTransfer?.files;
      const [file] = files;
      this.updatedFile = file;
    },
    onFil(file) {
      this.updatedFile = file;
    },
    onFileRenderer(file) {
      const reader = new FileReader()

      reader.addEventListener(
          'load',
          () => {
            this.attachmentPath = reader.result
            this.updatedFile = file;
          },
          false,
      )

      if (file) {
        reader.readAsDataURL(file)
      }
    },
    resetForm() {
      this.updatedFile = null
      this.attachmentPath = ''
    },
  },
};
</script>

<style lang="scss">
